export class Intervals {}

// Interval Keys
Intervals.DAILY = 'daily'
Intervals.DAILY_DATA = 'daily-data'
Intervals.WEEKLY = 'weekly'
Intervals.MONTHLY = 'monthly'
Intervals.SEMI_MONTHLY = 'semi-monthly'

// Interval Options for select2
// the keys for this object match the values of the above constants. Labels
// match STANDARD_INTERVAL_OPTIONS so every report's "Send frequency" reads alike.
Intervals.INTERVAL_OPTIONS = {
    daily: 'Daily (Monthly Data)',
    'daily-data': 'Daily (Day\'s Data)',
    weekly: 'Weekly',
    'semi-monthly': 'Semi-Monthly',
    monthly: 'Monthly',
}

// The four sends for reports with no "Day's Data" window of their own (e.g.
// Device Summary would report on an empty period), as their old settings
// pages offered.
Intervals.STANDARD_INTERVAL_OPTIONS = {
    daily: 'Daily',
    weekly: 'Weekly',
    'semi-monthly': 'Semi-Monthly',
    monthly: 'Monthly',
}

// Weekday Options
Intervals.WEEKDAY_OPTIONS = {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
}

// Semi-Month Options
Intervals.SEMI_MONTH_OPTIONS = {
    first: '1st Half (1 - 15)',
    last: '2nd Half (16 - End of Month)',
}
